<template>
  <div id="my-attendance">
    <div class="attendance-wrapper" v-if="!isEventAttendance">
      <AttendanceTitle :sideBar="sidebarProps" :cntAttendance="cnt_attendance"></AttendanceTitle>

      <div id="attendance_subtitle">{{ $t('mypage.attendance.subtitle') }}</div>
      <EventAttendanceBoard v-if="attendanceEvent?.isEvent !== null" :cnt_attendance="cnt_attendance" />
      <AttendanceBoard v-else :cnt_attendance="cnt_attendance" />
    </div>

    <div class="attendance-wrapper event" v-else>
      <div class="event-title">{{ texts.omz.title }}</div>
      <div class="event-content">{{ texts.omz.content }}</div>
      <OmzAttendance :usrAttend="cnt_attendance" :type="'sidebar'" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AttendanceTitle from '@/layouts/partials/Menus/AttendanceTitle';
import AttendanceBoard from '@/layouts/partials/Menus/components/AttendanceBoard';
import EventAttendanceBoard from '@/layouts/partials/Menus/components/EventAttendanceBoard';
import OmzAttendance from '@/views/Events/OMZAttendance.vue';

const texts = {
  ko: {
    omz: {
      title: 'OMZ 발행 기념 이벤트',
      content: '09.04 ~ 09.11까지 특별 출석이벤트를 진행합니다.',
    },
  },
  en: {
    omz: {
      title: 'OMZ Publishing Event',
      content: 'Special attendance event: 09/04 - 09/11.',
    },
  },
};

export default {
  props: {
    sideBar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AttendanceTitle,
    AttendanceBoard,
    EventAttendanceBoard,
    OmzAttendance,
  },
  computed: {
    ...mapState(['isMobile', 'lang', 'cnt_attendance', 'isEventAttendance', 'attendanceEvent']),
    sidebarProps() {
      return this.sideBar ? 'side-bar-' : '';
    },
    texts() {
      return texts[this.lang];
    },
  },
  methods: {
    attendanceImgUrl(day) {
      const isCoupons = (num) => (num === 7 ? 'my_coupons' : 'coupon');
      const baseImgText = `${this.$s3}/img/common/mypage/`;
      const isAttendance = day <= this.cnt_attendance;
      const attendaneImgUrl = isAttendance ? `_active${this.atdcImgNum(day)}` : '';
      /** ${$s3}/img/common/mypage/<<my_coupons | coupon >><<_active (2 | 3)>>.svg?${$ver} */
      const imgUrl = `${baseImgText}${isCoupons(day)}${attendaneImgUrl}.svg?${this.$ver}`;
      return imgUrl;
    },
    isCoupons: (num) => (num === 7 ? 's' : ''),
    atdcImgNum(num) {
      switch (num) {
        case 2:
        case 5:
          return '1';
        case 3:
        case 6:
          return '2';

        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

#my-attendance {
  margin: 0;
  padding: 16px 20px;
  padding-top: 10px;
  text-align: left;
  background-size: 100% auto !important;

  .attendance-wrapper {
    width: fit-content;
    min-width: 265px;
    margin: 0 auto;

    @include mobile {
      min-width: unset;
    }

    &.event {
      .event-title {
        color: #543905;
        font-size: 14px;
        font-weight: 500;
      }
      .event-content {
        color: #333;
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 8px;
      }
    }
  }

  .block-content {
    padding: 0;
  }
  .row {
    margin: 0 -4px;
  }
  #attendance_subtitle {
    font-size: 12px;
    margin-bottom: 6px;
    font-weight: 400;
    color: #333333;
  }
  .attendance_block {
    padding: 0;
    border: 1px solid #ededed;
  }
  img {
    width: 100%;
  }
}
</style>
